import { motion } from "framer-motion";
import { MessageCircle, CalendarCheck, Star } from "lucide-react";
import { CONTACT, IMAGES } from "../../lib/site";
import { useWhatsApp } from "../WhatsAppProvider";

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.8, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] } }),
};

export const Hero = () => {
    const { openPicker } = useWhatsApp();

    return(
  <section id="top" data-testid="hero-section" className="relative min-h-screen bg-ink text-white overflow-hidden flex items-center pt-28 pb-20">
    {/* glow orbs */}
    <div className="pointer-events-none absolute -top-32 -left-20 w-[36rem] h-[36rem] rounded-full bg-brand/25 blur-[140px]" />
    <div className="pointer-events-none absolute bottom-0 right-0 w-[28rem] h-[28rem] rounded-full bg-brand/10 blur-[120px]" />

    <div className="relative max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-14 items-center w-full">
      <div>
        <motion.div custom={0} variants={fadeUp} initial="hidden" animate="show" className="flex flex-wrap gap-2">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-xs font-semibold tracking-[0.12em] uppercase text-white/70">
            <span className="w-2 h-2 rounded-full bg-brand animate-pulse" /> Moncalieri · Via Del Ballo 1
          </span>
          <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-xs font-semibold tracking-[0.12em] uppercase text-white/70">
            <span className="w-2 h-2 rounded-full bg-brand" /> Torino · Corso Orbassano 214
          </span>
          <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-xs font-semibold tracking-[0.12em] uppercase text-white/70">
            <span className="w-2 h-2 rounded-full bg-brand" /> Torino · Via Pietro Cossa 13/c
          </span>
        </motion.div>

        <motion.h1 custom={1} variants={fadeUp} initial="hidden" animate="show"
          className="font-display font-extrabold tracking-tighter text-5xl md:text-6xl lg:text-7xl leading-[1.02] mt-6">
          Telefonia, Internet e Risparmio.
          <span className="block text-brand">Tutto per restare connessi.</span>
        </motion.h1>

        <motion.p custom={2} variants={fadeUp} initial="hidden" animate="show"
          className="mt-6 text-lg md:text-xl text-white/60 max-w-xl leading-relaxed">
          Ti aiutiamo a scegliere la soluzione migliore tra smartphone, offerte mobile,
          fibra e luce & gas — con consulenza reale e assistenza in negozio.
        </motion.p>

        <motion.div custom={3} variants={fadeUp} initial="hidden" animate="show" className="mt-9 flex flex-col sm:flex-row gap-4">
          <button type="button" onClick={() => openPicker()} data-testid="hero-whatsapp-btn"
            className="group inline-flex items-center justify-center gap-2 rounded-full bg-brand hover:bg-brand-hover px-8 py-4 text-base font-semibold transition-all duration-200 hover:scale-[1.03] shadow-lg shadow-brand/30">
            <MessageCircle className="w-5 h-5" /> Contattaci su WhatsApp
          </button>
          <a href="#contatti" data-testid="hero-consult-btn"
            className="inline-flex items-center justify-center gap-2 rounded-full border border-white/25 hover:border-white px-8 py-4 text-base font-semibold transition-all duration-200 hover:bg-white/5">
            <CalendarCheck className="w-5 h-5" /> Consulenza gratuita
          </a>
        </motion.div>

        <motion.div custom={4} variants={fadeUp} initial="hidden" animate="show" className="mt-10 flex items-center gap-3 text-sm text-white/60">
          <div className="flex text-brand">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" />)}
          </div>
          <span><strong className="text-white">1000+ clienti soddisfatti</strong> · consulenza senza impegno</span>
        </motion.div>
      </div>

      <motion.div initial={{ opacity: 0, scale: 0.94 }} animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1, delay: 0.3, ease: [0.22, 1, 0.36, 1] }} className="relative">
        <div className="absolute inset-4 rounded-[2.5rem] bg-brand/20 blur-3xl" />
        <img src={IMAGES.hero} alt="Assistenza smartphone in negozio Windonline"
          className="relative w-full rounded-[2.5rem] border border-white/10 object-cover" />
        <div className="absolute -bottom-5 -left-3 sm:left-6 rounded-2xl bg-white text-ink px-5 py-4 shadow-2xl">
          <p className="text-xs uppercase tracking-widest text-neutral-500 font-bold">Attivazioni</p>
          <p className="font-display font-bold text-lg">Rapide & sicure</p>
        </div>
      </motion.div>
    </div>
  </section>
  );
};
